import angular from 'angular';

const notesServices = angular.module('applicationModule.notesServices', []);

notesServices.factory('Notes', ['NotesAPI', function (NotesAPI) {
    'use strict';
    return {
        getList: function (appId, params) {
            return NotesAPI.getList(appId, params).then(function (response) {
                return response.data;
            });
        },
        get: function (noteId, appId) {
            return NotesAPI.get(noteId, appId);
        },
        post: function (note) {
            return NotesAPI.createNote(note);
        },
        save: function (note, editMode) {
            if (editMode) {
                return NotesAPI.editNote(note);
            } else {
                return NotesAPI.createNote(note);
            }
        },
        remove: function (noteId) {
            return NotesAPI.remove(noteId);
        }
    };
}]);

notesServices.service('NotesAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/note/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.get = function (noteId, appId) {
        return $http.get(API_URL + noteId, {params: {application_id: appId}});
    };

    this.createNote = function (notes) {
        return $http.post(API_URL, notes);
    };

    this.editNote = function (note) {
        return $http.put(API_URL + note.id, note);
    };

    this.remove = function (noteId) {
        return $http.delete(API_URL + noteId);
    };

}]);

export default notesServices;
